import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { Device } from "utils/device";

const Hero2025Content: FunctionComponent = () => {
  return (
    <S.Section id="virtual-tour">
      <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
        <iframe
          src="https://player.vimeo.com/video/1029268985?autoplay=1&amp;muted=1&amp;h=e8ed56dea4&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title="AllBright Tour"
        ></iframe>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;

  @media (min-width: ${Device.mobile}) {
  }

  @media (min-width: ${Device.tablet}) {
  }
`;

export default Hero2025Content;
